import request from '@/middleware/request'

const getContact = data => {
  return request({
    url: '/contacts/list',
    method: 'post',
    data
  })
}

const createContact = data => {
  return request({
    url: '/contacts',
    method: 'post',
    data
  })
}

const updateContact = (id, data) => {
  return request({
    url: `/contacts/${id}`,
    method: 'patch',
    data
  })
}

const deleteContact = id => {
  return request({
    url: `/contacts/${id}`,
    method: 'delete'
  })
}

export default {
  getContact,
  createContact,
  updateContact,
  deleteContact
}
